export default __webpack_public_path__ + "static/media/clock_fMT.fce272ff.svg";